/**
 * Copyright 2023 Design Barn Inc.
 */

'use client';

import React from 'react';
import { Client, Provider, cacheExchange, fetchExchange } from 'urql';

if (!process.env['NEXT_PUBLIC_AUTH_GRAPHQL_URL']) {
  throw new Error('NEXT_PUBLIC_AUTH_GRAPHQL_URL  environment variable is not set');
}

const client = new Client({
  url: process.env['NEXT_PUBLIC_AUTH_GRAPHQL_URL'],
  exchanges: [cacheExchange, fetchExchange],
  fetchOptions: {
    credentials: 'include',
  },
});

export const UrqlProvider = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  return <Provider value={client}>{children}</Provider>;
};
